var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-fixed-bottom-popup"},[_c('button',{staticClass:"mobile-fixed-bottom-popup__button-cross",attrs:{"type":"button","aria-label":"Закрыть окно"},on:{"click":_vm.onClose}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }